<template>
  <div>
    <div class="header-wrapper-exception superpro-banner">
      <h2>SuperPro</h2>
      <hr class="line" />
    </div>
    <b-container>
      <div class="grid">
        <div class="text">
          <p>
            SuperPro to innowacyjny australijski producent poliuretanowych tulei
            zawieszenia, wahaczy, stabilizatorów oraz innych komponentów
            zawieszenia do pojazdów terenowych (4x4) i sportowych.
          </p>
          <p>
            Firma SuperPro ma swoją siedzibę w Brisbane, w stanie Queensland,
            gdzie prowadzi cały proces inżynieryjny i produkcyjny, co gwarantuje
            najwyższą jakość produktów. Stworzone, by przewyższać oczekiwania –
            specjalnie opracowane, wysokiej jakości komponenty SuperPro
            zapewniają lepszą stabilność, prowadzenie i kontrolę zawieszenia
            zarówno w warunkach drogowych, jak i terenowych. SuperPro wspiera
            zespół badawczo-rozwojowy pracujący na pełen etat, który posiada
            ponad 45 lat doświadczenia w branży motoryzacyjnej, zdobywanego w
            najtrudniejszych warunkach Australii. Produkty SuperPro są
            zaprojektowane tak, aby były proste i skuteczne, co pozwala
            zaoszczędzić czas podczas montażu i zapewnia najefektywniejsze
            rozwiązania zawieszenia.
          </p>
        </div>
        <div class="image">
          <picture>
            <source
              type="image/webp"
              srcset="./../../assets/brands-logos/superpro.png"
            />
            <img
              src="./../../assets/brands-logos/superpro.png"
              alt="Superpro"
            />
          </picture>
        </div>
      </div>
    </b-container>
    <page-header
      :text="$t('importantLinks')"
      font="black"
      back="white"
    ></page-header>
    <b-container>
      <div class="link-items">
        <router-link to="/catalogue/superpro">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>
            {{ $t("catalogue") }} ON-LINE
          </div>
        </router-link>
        <a href="https://www.superpro.com.au/" target="_blank">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>{{ $t("website") }}
          </div>
        </a>
        <a
          href="https://www.youtube.com/@SuperProSuspensionParts"
          target="_blank"
        >
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>{{ $t("youtube") }}
          </div>
        </a>
      </div>
      <tire />
    </b-container>
  </div>
</template>

<script>
import PageHeader from "@/components/common/PageHeader.vue";
import Tire from "@/components/home/Tire";

import { mapGetters } from "vuex";

export default {
  name: "SuperProPl",
  components: { Tire, PageHeader },
  computed: {
    ...mapGetters(["isUserLogged"])
  }
};
</script>
